import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux'
import queryString from "query-string";
import _get from "lodash/get";

//Components
import Loading from './Loading';
import ModalRoot from '../containers/common/ModalRoot';
import AlertPreferences from '../containers/monitoring/AlertPreferences';

//Actions
import {loginRefresh} from '../actions/auth';
import {tokensByNslToken} from "../actions/auth";
import {TOKENS_BY_NSL_TOKEN_SUCCESS} from "../actions/authConstants";
import {ACCOUNT_CONTACT_PREF_GET_SUCCESS} from '../actions/account';

//Helpers
import log from '../helpers/log';
import {getLangCode, getLangCodeFromLocale, setLangCode, stringBundle} from '../stringBundle';


class App extends Component {
  constructor(props) {
    super(props);
    this.sendMessage = this.sendMessage.bind(this);
    this.receiveMessage = this.receiveMessage.bind(this);
    this.notifyParentComplete = this.notifyParentComplete.bind(this);
    this.confirmPrefs = this.confirmPrefs.bind(this);
    this.skipPrefs = this.skipPrefs.bind(this);
    this.localizedStringBundle = {};

    this.state = {
      missingToken: false,
      notifiedParentMissingToken: false,
    };
  }

  /**
   * Receives messages from window parent.
   */
  receiveMessage(event) {
    if (event.data && typeof event.data === 'object' && event.data.type === 'TOKEN'
      && event.data.payload && typeof event.data.payload === 'object') {

      const token = event.data.payload.token;

      if (token && typeof token === 'string') {
        this.setState({'missingToken': false});
      }

      this.setLanguageFromQueryString();
      this.props.dispatch(tokensByNslToken(token)).then(
        (result) => {
          if (result.type === TOKENS_BY_NSL_TOKEN_SUCCESS) {
            this.props.dispatch(loginRefresh()); // test for dashboard monitoring;
          }
        });
    }
  }

  /**
   * Sends messages to window parent.  If this window is an iframe, the message is sent to the parent of the iframe.
   */
  sendMessage(payload, host) {
    if (typeof payload !== 'object') {
      throw new Error('expected payload to be a JSON object');
    }
    try {
      window.parent.postMessage(payload, host);
    } catch (error) {
      log.error(error);
    }
  }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) {
      this.unsubscribeFromHistory();
    }
    window.removeEventListener('message', this.receiveMessage, false);
  }

  notifyParentComplete() {
    this.sendMessage({type: 'APP_DONE', payload: {message: 'App Done'}}, window.REACT_APP_PARENT_HOST);
  }

  notifyParentLoaded() {
    this.sendMessage({type: 'APP_LOADED', payload: {message: 'App loaded'}}, window.REACT_APP_PARENT_HOST);
  }

  notifyParentNslError() {
    this.sendMessage({
      type: 'APP_ERROR',
      payload: {errorCode: "T_ACCESSDENIED", message: "NSL error.  Cannot authenticate."}
    }, window.REACT_APP_PARENT_HOST);
  }

  notifyParentMissingToken() {
    this.sendMessage({
      type: 'APP_GET_TOKEN',
      payload: {message: "No access token provided to host. Cannot authenticate."}
    }, window.REACT_APP_PARENT_HOST);
  }

  confirmPrefs() {
    log.track('alerts','click','alert-prefs-confirm');
    this.notifyParentComplete();
  }

  skipPrefs() {
    log.track('alerts','click','alert-prefs-skip');
    this.notifyParentComplete();
  }

  setLanguage(dispLocale) {
    const langCodeFromLocale = getLangCodeFromLocale(dispLocale);
    setLangCode(langCodeFromLocale);
    this.localizedStringBundle = stringBundle(getLangCode());
  }

  setLanguageFromQueryString() {
    let qs = queryString.parse(this.props.location.search);
    let dispLocale = qs.dispLocale || 'iso3:us';
    if (dispLocale.indexOf(':') !== -1) {
      dispLocale = dispLocale.split(':')[1];
    }
    this.setLanguage(dispLocale);
  }

  renderNslError() {
    return (
      <div >
        <div className="flex m-4 justify-center">
          <i className="material-icons text-red text-5xl">&#xE001;</i>
          <div className="flex flex-col ml-4 font-bold justify-center">
            <div className='text-red'>{this.localizedStringBundle.PAGE_NOT_ABLE_TO_LOAD_LINE1}</div>
            <div className="mt-1">
              <p>{this.localizedStringBundle.PAGE_NOT_ABLE_TO_LOAD_LINE2}</p>
              <p>{this.localizedStringBundle.PAGE_NOT_ABLE_TO_LOAD_PHONE1}</p>
            </div>
          </div>
        </div>
        <div className="flex flex-row w-full mb-8 mt-4 px-8 justify-center pt-8">
          <button onClick={this.notifyParentComplete} id="completedStep"
                  className="btn h-10 w-22.5 text-black font-semibold border-1 border-yellow" type="submit">
            {this.localizedStringBundle.SKIP}
          </button>
        </div>
      </div>
    );
  }

  renderAlertPreferences() {
    return (
      <div>
        <ModalRoot/>
        <React.StrictMode>
          <div className="app flex flex-col w-full bg-white">
            <div className="flex flex-col w-full mx-auto">
              <div className="hidden">{process.env.REACT_APP_LABEL}</div>
              <Switch>
                <Route path="/alertPreferences" exact={true} component={AlertPreferences}></Route>
              </Switch>
            </div>
          </div>
        </React.StrictMode>
        <div className="flex flex-row w-full mb-8 mt-4 px-8 justify-between">
          <button onClick={this.skipPrefs} id="completedStep"
                  className="btn h-10 w-22.5 text-black font-semibold border-1 border-yellow" type="submit">
            {this.localizedStringBundle.SKIP}
          </button>
          <button onClick={this.confirmPrefs} id="completedStep"
                  className="btn h-10 w-56 text-black font-semibold bg-yellow hover:bg-yellow-dark focus:bg-yellow-darker border-1 border-yellow"
                  type="submit">
            {this.localizedStringBundle.CONFIRM_MY_PREFERENCES}
          </button>
        </div>
      </div>
    )
  }

  parseQueryString() {
    let qs = queryString.parse(this.props.location.search);
    if (!qs.nsl_access_token) {
      this.setState({'missingToken':true}, function() {
        if (!this.state.notifiedParentMissingToken) {
          this.notifyParentMissingToken();
          this.setState({'notifiedParentMissingToken':true});
        }
      });
      return;
    }

    let dispLocale = qs.dispLocale || 'iso3:us';
    if (dispLocale.indexOf(':') !== -1) {
      dispLocale = dispLocale.split(':')[1];
    }
    this.setLanguage(dispLocale);
    this.props.dispatch(tokensByNslToken(qs.nsl_access_token)).then(
      (result) => {
        if (result.type === TOKENS_BY_NSL_TOKEN_SUCCESS) {
          this.props.dispatch(loginRefresh()); // test for dashboard monitoring;
        }
      });
  }

  componentDidMount() {
    window.addEventListener('message', this.receiveMessage, false);
    this.parseQueryString();
  }

  render() {
    if (this.state.missingToken || !this.props.auth || this.props.auth.nslLoading) {
      return (<Loading/>);
    } else if (this.props.auth.error) {
      this.notifyParentNslError();
      return this.renderNslError();
    } else {
      if (_get(this.props.account, 'status') === ACCOUNT_CONTACT_PREF_GET_SUCCESS) {
        this.notifyParentLoaded();
      }
      // check if the following shows up in the logs for cases where cct doesn't receive APP_LOADED
      return this.renderAlertPreferences();
    }
  }
}

App.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }),
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  account: PropTypes.object
};

function mapStateToProps(state) {
  let {auth, account} = state
  return {auth, account};
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js